import React, {useContext, useState} from 'react';
import {styled} from '@mui/styles';
import {DispatchContext} from '../../store';
import {useFormikContext} from 'formik';
import {uploadAction, uploadPhoto} from '../../services/PhotoServices';
import {SNACKBAR_OPEN} from '../../reducers';
import Box from '@mui/material/Box';
import {Grid, Typography} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {Images} from '../Assets/Images';

const Input = styled('input')({
  display: 'none',
});
export default function BeforeConservationPhoto({setImageId, imgId, conservationImgId}) {
  const dispatch = useContext(DispatchContext);
  const [images, setImages] = useState([]);
  const {values, setFieldValue} = useFormikContext();
  const id = parseInt(imgId);

  const handleAddMuseumPhoto = ({target: {files}}, index) => {
    const newImages = Array.from(files)
      .slice(0, 5 - images.length)
      .map(file => URL.createObjectURL(file));

    const image = files[0];
    const formData = new FormData();
    formData?.append('file', image);

    uploadPhoto('post', null, formData, {'Content-Type': 'multipart/form-data'}).then(res => {
      setImageId(prevIds => [...prevIds, res?.data?.id]);
      setImageId(prevArtefactImgIds => [...prevArtefactImgIds, res?.data?.id]);

      const newPhoto = {id: res?.data?.id, file: res?.data?.file};

      if (imgId) {
        if (values?.before_photos) {
          values?.before_photos.push(newPhoto);
          setFieldValue('photos', [...values?.before_photos]);
        } else {
          setFieldValue('photos', [...values?.photos, newPhoto]);
        }
      }
    });
    setImages(prevImages => [...prevImages, ...newImages]);
  };

  const handleRemoveImage = async (index, id) => {
    try {
      if (imgId) {
        await uploadAction('delete', id);
      }

      if (!imgId) {
        setImages(prevImages => prevImages.filter((image, i) => i !== index));

        const imageIdToDelete = conservationImgId[index];
        await uploadAction('delete', imageIdToDelete);

        const updatedImagesState = [...conservationImgId];
        updatedImagesState.splice(index, 1);
        setImageId(updatedImagesState);
      }

      // setImageId(prevArtefactImgIds => prevArtefactImgIds.filter(imgId => imgId !== id));
      // setImages(prevImages => prevImages.filter((image, i) => i !== index));

      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Image removed successfully'}
      });
    } catch (error) {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'error', message: 'Error removing image: ' + error}
      });
    }
  };


  return (
    <React.Fragment>
      <Box sx={{position: 'relative', mt: 1}}>
        <label htmlFor="cover-button-file" className="hand-cursor">
          <Box style={{
            border: '1px dashed #929191',
            width: '100%',
            height: 100,
            objectFit: 'contain',
            borderRadius: 5
          }}>
            <Grid container spacing={2} sx={{p: 1}}>
              {(values?.before_photos || images)?.map((image, index) => (
                <Grid key={index} item sm={2.4}>
                  <div>
                    <img draggable={false} width={'80%'} height={55}
                         style={{objectFit: 'cover'}}
                         src={image?.file || image?.data?.file || image || Images?.logoWhite}
                         alt="museum_photo"/>
                    {id ?
                      <IconButton
                        onClick={() => handleRemoveImage(index, image?.id)}
                        aria-label="delete"
                      >
                        <RemoveCircleIcon sx={{color: 'red'}}/>
                      </IconButton> :
                      <IconButton
                        onClick={() => handleRemoveImage(index)}
                        aria-label="delete"
                      >
                        <RemoveCircleIcon sx={{color: 'red'}}/>
                      </IconButton>
                    }
                  </div>
                </Grid>
              ))}
            </Grid>
          </Box>
          <label className="hand-cursor" style={{position: 'absolute', bottom: '30%', left: '25%'}}>
            <Input accept="image/*" id="cover-button-file" type="file" multiple
                   onChange={(e) => handleAddMuseumPhoto(e, values?.photo_ids?.length)}/>
            {(values?.before_photos || images)?.length === 0 && (
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}} color="primary"
                   aria-label="upload picture">
                <CloudUploadIcon sx={{color: '#343434'}}/>
                <Typography sx={{color: '#343434'}}>Upload before picture</Typography>
              </div>)}
          </label>
        </label>
      </Box>
    </React.Fragment>
  );
};